// @ts-ignore
import './TimeSelector.scss';

import { getLocalTimeString, useTranslation } from '../../utils';

import type { TTimeSelectorProps } from '../../utils/types';
import { useHandlers } from './hooks';

const TimeSelector = ({ availableTimes, onTimeSelect, value, selectedService }: TTimeSelectorProps) => {
  const { t } = useTranslation();
  const { createAppointment } = useHandlers({
    facilityId: selectedService.id,
    value,
  });

  return (
    <div className='timeSelector'>
      {!!availableTimes.length && (
        <>
          <h3 className='sectionTitle'>
            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
              <circle cx='12' cy='12' r='9' />
              <path d='M12 7v5l3 3' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
            {t('Web.Text_select_time_slot_web')}
          </h3>

          <div className='list'>
            {availableTimes.map((slot, index) => (
              <div
                className={`timeSlot ${value?.starts === slot.starts ? 'selected' : ''}`}
                key={index}
                onClick={() => onTimeSelect(slot)}>
                {getLocalTimeString(slot.starts)} - {getLocalTimeString(slot.ends)}
              </div>
            ))}
          </div>
        </>
      )}

      <button
        className='submitBtn'
        onClick={createAppointment}
        disabled={!value}
      >
        <span>{t('Create appointment (client).Text_create_appointment')}</span>
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' className='arrow'>
          <path d='M5 12h14M13 6l6 6-6 6' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </button>
    </div>
  );
};

export default TimeSelector;